(() => {
  const SALE = '#7a1e2b'; // WC burgundy

  const apply = (scope = document) => {
    // 1) Force CSS variables too (some themes reference these vars)
    scope.querySelectorAll('.quick-cart, .quick-cart__container, .quick-cart__drawer').forEach(el => {
      el.style.setProperty('--color-sale-price-popups-drawers', SALE, 'important');
      el.style.setProperty('--color-sale-price-popups', SALE, 'important');
      el.style.setProperty('--color-sale-price', SALE, 'important');
    });

    // 2) Force actual sale nodes
    scope.querySelectorAll(
      '.quick-cart [data-is-sale="true"], .quick-cart__container [data-is-sale="true"]'
    ).forEach(el => {
      el.style.setProperty('color', SALE, 'important');
      el.style.setProperty('-webkit-text-fill-color', SALE, 'important'); // Safari/iOS
    });
  };

  // Run once on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  // Re-apply after AJAX renders / drawer updates
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;

        // If quick-cart subtree appeared/changed, re-apply
        if (
          n.matches?.('.quick-cart, .quick-cart__container, .quick-cart__drawer') ||
          n.querySelector?.('.quick-cart__container, [data-is-sale="true"]')
        ) {
          apply(n);
          return;
        }
      }
    }
  });

  mo.observe(document.body, { childList: true, subtree: true });
})();